/* istanbul ignore file */
import { boolean as codecBoolean } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const StudentPaymentEnabledSettingParser = 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('STUDENT_PAYMENT_ENABLED')],
    ['value', /* #__PURE__ */ parsers.maybeNull(codecBoolean)],
]);
export class StudentPaymentEnabledSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return StudentPaymentEnabledSettingParser.decode(input).map(res => new StudentPaymentEnabledSetting(res));
    }
    static unsafeDecode(input) {
        return StudentPaymentEnabledSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return StudentPaymentEnabledSettingParser.encode(data);
    }
    static schema() {
        return StudentPaymentEnabledSettingParser.schema();
    }
}
